"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeModifierImpl = exports.DateTimeProviderImpl = exports.UTCTimeZone = exports.DateTimeBridgeImpl = exports.FORMAT_RAW = exports.DateTimeModifier = exports.DateTimeProvider = void 0;
const clock_1 = require("@almservices-cl/clock");
Object.defineProperty(exports, "DateTimeBridgeImpl", { enumerable: true, get: function () { return clock_1.DateTimeBridgeImpl; } });
Object.defineProperty(exports, "DateTimeProvider", { enumerable: true, get: function () { return clock_1.DateTimeProvider; } });
Object.defineProperty(exports, "DateTimeModifier", { enumerable: true, get: function () { return clock_1.DateTimeModifier; } });
Object.defineProperty(exports, "FORMAT_RAW", { enumerable: true, get: function () { return clock_1.FORMAT_RAW; } });
Object.defineProperty(exports, "UTCTimeZone", { enumerable: true, get: function () { return clock_1.UTCTimeZone; } });
class DateTimeProviderImpl extends clock_1.DateTimeProviderImpl {
    constructor(dateTimeConfigCacheInterface, locale) {
        super(locale);
        this.setFormats = (dateTimeFormat, dateFormat, timeFormat) => {
            this.dateTimeFormat = dateTimeFormat;
            this.dateFormat = dateFormat;
            this.timeFormat = timeFormat;
        };
        dateTimeConfigCacheInterface.onChange(this);
    }
}
exports.DateTimeProviderImpl = DateTimeProviderImpl;
class DateTimeModifierImpl extends clock_1.DateTimeModifierImpl {
    constructor(dateTimeConfigCacheInterface) {
        super();
        this.setFormats = (dateTimeFormat, dateFormat) => {
            this.dateTimeFormat = dateTimeFormat;
            this.dateFormat = dateFormat;
        };
        dateTimeConfigCacheInterface.onChange(this);
    }
}
exports.DateTimeModifierImpl = DateTimeModifierImpl;
//# sourceMappingURL=DateTimeProvider.js.map